var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    ref: "rootRef",
    staticClass: "goodslist-template1"
  }, [_c("IndexProduct", {
    attrs: {
      screenWidth: _vm.rootWidth,
      data: _vm.formData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };